// core/data/cases.ts — Typed seed for moderation cases.
//
// Faithfully ported from legacy src/scripts/data/cases.js.
// NOTE: Behavior (state machine: castVote, appeal, createCaseFromReport) lives in
// core/services/casesService.ts — NOT here. This module is pure static seed data.
//
// Seed: 4 post cases (lifecycle across distinct posts) + 1 account case (under-review).
// The 'decided' entries replicate the legacy seeded outcomes exactly.

import type { CaseRecord } from '@/core/models/case';

// NOTE on IDs: seed cases use 'case-S01'..'case-S05' (prefixed 'S') so they cannot
// collide with service-generated IDs ('case-001', 'case-002', …). This ensures that
// _resetForTest() can start the seq counter at 0 without any ID conflict.
// The 4 post-cases now target REAL posts (post-011/012/014/015) so council headlines
// resolve and the feed surfaces seeded moderation status. These ids are disjoint from
// the test range (post-001..006, 010, 099) and avoid post-013 (WayneTech/admin).
export const seedCases: CaseRecord[] = [
  {
    id: 'case-S01',
    kind: 'post',
    postId: 'post-011',
    category: 'coordinated-abuse',
    context: 'Looks like a coordinated pile-on from brand-new accounts.',
    reporter: '@SeenAndUnseen',
    team: 'Team Charlie',
    time: '12m',
    reportWeight: 'Medium',
    status: 'under-review',
    votes: { keep: 1, remove: 2 },
    decision: null,
    appeal: null,
  },
  {
    id: 'case-S02',
    kind: 'post',
    postId: 'post-012',
    category: 'scams',
    context: '',
    reporter: '@LibertyMind',
    team: 'Team Alpha',
    time: '40m',
    reportWeight: 'High',
    status: 'under-review',
    votes: { keep: 0, remove: 3 },
    decision: null,
    appeal: null,
  },
  {
    id: 'case-S03',
    kind: 'post',
    postId: 'post-015',
    category: 'terrorism',
    context: 'Reported for glorifying violence.',
    reporter: '@TruthWarrior',
    team: 'Team Bravo',
    time: '5h',
    reportWeight: 'High',
    status: 'decided',
    votes: { keep: 2, remove: 4 },
    decision: {
      outcome: 'removed',
      explanation: 'Team Bravo: removed under Terrorism. 4 of 7 voted to remove.',
      team: 'Team Bravo',
    },
    appeal: null,
  },
  {
    id: 'case-S04',
    kind: 'post',
    postId: 'post-014',
    category: 'fraud',
    context: '',
    reporter: '@FreeThinker',
    team: 'Team Alpha',
    time: '6h',
    reportWeight: 'Low',
    status: 'decided',
    votes: { keep: 4, remove: 1 },
    decision: {
      outcome: 'kept',
      explanation: 'Team Alpha: kept visible under Fraud. 4 of 7 voted to keep. The post stays fully visible.',
      team: 'Team Alpha',
    },
    appeal: null,
  },
  {
    id: 'case-S05',
    kind: 'account',
    accountId: 'liberty-mind',
    category: 'coordinated-abuse',
    context: 'Multiple accounts reporting organized harassment from this account.',
    reporter: '@OpenMindX',
    team: 'Team Charlie',
    time: '1h',
    reportWeight: 'Medium',
    status: 'under-review',
    votes: { keep: 1, remove: 1 },
    decision: null,
    appeal: null,
  },
];
